import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { SPACE_REPOSITORY } from '../../core';
import { SPACE_SEARCH_API } from '../data-sources/apis/space.api';
export var SpaceWebRepository = /*#__PURE__*/function () {
  function SpaceWebRepository(spaceApi) {
    _classCallCheck(this, SpaceWebRepository);

    this.spaceApi = spaceApi;
  }

  _createClass(SpaceWebRepository, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var response, spaceResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.spaceApi.search(query);

              case 2:
                response = _context.sent;

                if (!response.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(response));

              case 5:
                spaceResponse = response.getValue();
                return _context.abrupt("return", Result.ok(spaceResponse));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }]);

  return SpaceWebRepository;
}();
export var spaceWebRepositoryProvider = {
  provide: SPACE_REPOSITORY,
  useFactory: function useFactory(spaceApi) {
    return new SpaceWebRepository(spaceApi);
  },
  inject: [SPACE_SEARCH_API]
};